import { Field } from "formik";
import { FormSelect } from "components/Inputs";
import cx from "classnames";
import s from "components/_Modals/ProjectDetailsModal/ProjectDetailsModal.module.scss";
import React from "react";
import { useTranslate, useUserDepartments } from "hooks";

export const DepartmentSelect = () => {
  const translate = useTranslate();
  const { options } = useUserDepartments();

  return (
    <Field
      component={FormSelect}
      name="departmentId"
      wrapperClassName={cx(s.fieldWithoutMarginBottom)}
      autoFocus={true}
      data-recording-disable={true}
      label="Department"
      options={options}
      tooltipText={translate("PROJECT_LOCATION_SELECT_TOOLTIP_TEXT")}
    />
  );
};
